import React, { useEffect, useState } from 'react'
import Script from 'next/script'

// Sumo is a marketing popup script with no app dependency. Loading it eagerly
// costs ~800ms of main-thread time, hurting LCP/INP. Defer it until AFTER the
// window load event, then load on the user's first interaction or a short
// timeout fallback — so it never competes with initial render or early INP.
export default function Sumo() {
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    if (!process.env.SUMO_SITE_ID) return undefined

    let triggered = false
    let timer
    const events = ['scroll', 'pointerdown', 'keydown', 'touchstart']

    const cleanup = () => {
      events.forEach((event) => window.removeEventListener(event, trigger))
      clearTimeout(timer)
      window.removeEventListener('load', arm)
    }

    function trigger() {
      if (triggered) return
      triggered = true
      cleanup()
      setShouldLoad(true)
    }

    // Only arm the triggers once the page has finished loading, so the idle
    // window can never open before first paint.
    function arm() {
      events.forEach((event) =>
        window.addEventListener(event, trigger, { once: true, passive: true })
      )
      timer = setTimeout(trigger, 3000)
    }

    if (document.readyState === 'complete') arm()
    else window.addEventListener('load', arm, { once: true })

    return cleanup
  }, [])

  if (!shouldLoad || !process.env.SUMO_SITE_ID) return null

  return (
    <Script
      id="sumo"
      src="//load.sumo.com/"
      data-sumo-site-id={process.env.SUMO_SITE_ID}
      strategy="lazyOnload"
    />
  )
}
